module.exports = __webpack_public_path__ + "static/media/usage-sample-mobile.ff05fa07.svg";